<template>
    <div class="grid-content">
        <div class="grid-item grid-item-half grid-item-break-half">
            <r-input
                label="Postmark server API token"
                v-model="cred.serverApiToken"
                password
                :validate="$v.cred.serverApiToken"
                help-text="Your Postmark server API token."/>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import BaseCredentials from './base-credentials';

    export default {
        name: 'postmark',
        extends: BaseCredentials,
        validations: {
            cred: {
                serverApiToken: {required},
            },
        },
        methods: {
            getValidationAggregate() {
                return {
                    name: 'postmark',
                    beforeValidation: () => this.isActiveType && this.$v.$touch(),
                    rules: () => (this.isActiveType ? [
                        {
                            name: `The Postmark server API token is required.`,
                            delegate: () => this.$v.cred.serverApiToken.$error,
                        },
                    ] : []),
                };
            },
        },
    };
</script>

<style scoped>

</style>
